import { observer } from 'mobx-react'
import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import DashboardFooter from './DashboardFooter'
import DashboardNav from './DashboardNav'
import DashboardVM from './DashboardVM'
import Learn from './Learn'
import Lobby from './Lobby'
import Nfts from './Nfts'
import OurToken from './OurToken'
import Shop from './Shop'
import Socials from './Socials'

export function Dashboard({ vm }: { vm: DashboardVM }) {
  return (
    <div className="margin-bottom-4">
      <DashboardNav />
      <Route exact path="/dashboard/lobby" render={() => <Lobby vm={vm} />} />
      <Route exact path="/dashboard/our-token" render={() => <OurToken vm={vm} />} />
      <Route exact path="/dashboard/shop" render={() => <Shop />} />
      <Route exact path="/dashboard/learn" render={() => <Learn vm={vm} />} />
      <Route exact path="/dashboard/nfts" render={() => <Nfts />} />
      <Route exact path="/dashboard/socials" render={() => <Socials />} />
      <Route exact path="/dashboard">
        <Redirect to="/dashboard/lobby" />
      </Route>

      <DashboardFooter />
    </div>
  )
}

export default observer(Dashboard)
